import { createReducer } from '@reduxjs/toolkit';
import * as UIActions from '../../actions/ui';
import { bpmTasksAvailable, caseDetailAvailable, activeProcessId, getBPMDetails, ignoreEvidence } from '../../actions/bpm-steps.action';
import { setActiveCaseRun } from '../cases/process-id-selection';
import { bpmSteps, caseUtils } from '@codametrix/ui-common';
import { jumpContext } from '../../actions/contexts.action';
export const InitialState = {
    stages: [],
    loading: true,
    locked: false,
    activeCase: {},
    activeCaseRun: {},
    evidence: {},
    showRawJSON: false
};
const reducer = createReducer(InitialState, (builder)=>{
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState
        }));
    builder.addCase(bpmTasksAvailable, (state, action)=>{
        const fullEvidence = action.payload;
        const { activeCaseRun } = state;
        const stages = bpmSteps.stepsToStages(fullEvidence[activeCaseRun.process_instance_id]);
        return {
            ...state,
            stages,
            evidence: fullEvidence
        };
    });
    builder.addCase(UIActions.parentDidNavigate.type, (state, action)=>({
            ...state,
            locked: !action.payload
        }));
    builder.addCase(caseDetailAvailable, (state, action)=>{
        const { caseDetail, processId } = action.payload;
        const activeCaseRun = caseUtils.getCaseRun(caseDetail, processId);
        return {
            ...state,
            activeCase: caseDetail,
            activeCaseRun
        };
    });
    builder.addCase(getBPMDetails.pending, (state)=>({
            ...state,
            loading: true
        }));
    builder.addCase(getBPMDetails.fulfilled, (state)=>({
            ...state,
            loading: false
        }));
    builder.addCase(activeProcessId, (state, action)=>{
        const processId = action.payload;
        const { activeCase, activeCaseRun, evidence } = state;
        const newActiveCaseRun = setActiveCaseRun(activeCase.caseRuns, processId) ?? activeCaseRun;
        const stages = bpmSteps.stepsToStages(evidence[processId]);
        return {
            ...state,
            stages,
            activeCaseRun: newActiveCaseRun
        };
    });
    builder.addCase(ignoreEvidence, (state, action)=>({
            ...state,
            showRawJSON: action.payload
        }));
});
export default reducer;
